/*
input-patterns.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('inputPatterns',['angular'], function () {

    // Module Definition
    var mod = angular.module('Services.InputPatterns', []);

    /**
     * @name inputPatterns
     * @type factory
     *
     * @description
     * A factory that provides input field patterns: i.e. <input pattern="xxx">.
     */
    mod.factory('inputPatterns', function () {

        function matches(str, pattern) {
            if (typeof str === 'undefined' || typeof pattern === 'undefined' || str === null || str === '') {
                return false;
            }
            var regex = (typeof pattern === 'string' ? new RegExp(pattern) : pattern.constructor.toString().match(/function (\w*)/)[1] === 'RegExp' ? pattern : null);
            if (regex == null) {
                return false;
            }
            return regex.test(str + '');
        }

        return {

            matches: matches,

            // #####
            zipCode: /(^\d{5}$)/,

            // ##### or #####-####
            zipCodePlus4: /(^\d{5}$)|(^\d{5}-\d{4}$)/,

            zipCodeUK: /(^(\d|\w|\s|[@#$%\"!#$%&'()*+,-.\/:;<=>?@\\ ^_`{|}~])+$)/,

            zipCodeJapan: /(^(\d){3}-(\d){4}$)/,

            // +# or +# ### or +###
            phoneCountryCode: /^\+\d\s\d+$|^\+\d+$/,

            password: /^((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%\"!#$%&'(*)+,-.\/:;<=>?@\\ ^_`{|}~]).{8,32})$/,

            integer: /^[-+]?[0-9]+$/,

            float: /^[-+]?[0-9]*\.?[0-9]+$/,

            currency: /^[0-9]*\.[0-9]{2,2}$/,

            // from http://stackoverflow.com/questions/2385701/regular-expression-for-first-and-last-name
            name: /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/,

            // from http://stackoverflow.com/questions/4338267/validate-phone-number-with-javascript
            phone: /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\. ]{0,1}[0-9]{3}[-\s\. ]{0,1}[0-9]{4}$/,

            //input patterns for port
            portPattern: /(^[0-9]*$)/,

            //input patterns for ip address
            ipPattern: /^(?!0)(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d)(\.|$)){4}$/,

            phoneNumberUK: /(^\d{7,13}$)/,

            phoneNumberFrance: /(^\d{9,12}$)/,

            phoneNumberGermany: /(^\d{9,12}$)/,

            // from http://blog.trojanhunter.com/2012/09/26/the-best-regex-to-validate-an-email-address/
            // The top-level domain name can be of maximum 63 characters.
            email: /^[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\.[a-zA-Z]{2,63}$/,

            usZip: /^[1-9]{5}(-[0-9]{4})?$/,

            ipAddress: /^((([2][5][0-5]|([2][0-4]|[1][0-9]|[0-9])?[0-9])\.){3})([2][5][0-5]|([2][0-4]|[1][0-9]|[0-9])?[0-9])$/,

            // from https://www.owasp.org/index.php/OWASP_Validation_Regex_Repository
            url: /^((((file?|https?|ftps?|gopher|telnet|nntp):\/\/)|(mailto:|news:))(%[0-9A-Fa-f]{2}|[-()_.!~*';\/?:@&=+$,A-Za-z0-9])+)([).!';\/?:,][[:blank:]])?$/,

            orgPathRegExp: /^[a-z0-9]+$/i,

            groupNameRegExp: /^[ A-Za-z0-9\u00C0-\u024F_\\+]*$/
        };

    });

});

